import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WaterBody } from './models/water-body';

@Injectable({ providedIn: 'root' })
export class WaterBodySelectionService {
  readonly selectedWaterBody$ = new BehaviorSubject<WaterBody | null>(null);

  selectWaterBody(wb: WaterBody | null): void {
    this.selectedWaterBody$.next(wb);
  }
}
